import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

const ServiceCard = ({ service, className }) => {
  return (
    <div className={className}>
      <div>
        <div className="mb-6 flex h-full w-full flex-1 flex-col items-center justify-center bg-bbc-gradient-6 px-3 shadow-[0px_4px_8px_rgba(0,0,0,0.1)] lg:mb-10">
          <Img className="py-20" {...service?.image} />
        </div>
        <div className="mb-10 text-left">
          <Title
            text={service?.title}
            as="h3"
            className={`group-hover:text-primary text-lg font-semibold leading-relaxed text-bbc-brand-700 line-clamp-2 ${
              service?.description ? "mb-6" : ""
            }`}
          />
          {service?.description && (
            <p className="text-black">
              {service.description}{" "}
              {service.link ? (
                <a
                  href={service.link.url}
                  rel="noreferrer"
                  className="font-medium text-bbc-primary hover:text-bbc-secondary-300"
                >
                  {service.link.summary}
                </a>
              ) : (
                ""
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

const WhoWeServes = ({ title, subTitle, partners }) => {
  return (
    <>
      <div className="container relative z-10 text-center lg:text-left">
        <Title
          text={title}
          className="title-h2 mb-2 text-bbc-30px text-bbc-brand-800 lg:text-bbc-40px"
        />
        <Title
          text={subTitle}
          className="title-h2 mb-6 text-bbc-30px text-bbc-brand-700 lg:text-4xl lg:leading-[50px]"
        />
        <div className="row justify-center lg:justify-between">
          {partners.length > 0 &&
            partners.map((item, index) => (
              <ServiceCard
                key={index}
                service={item}
                className="md:col-8 lg:col-4"
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default WhoWeServes;

WhoWeServes.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  partners: PropTypes.array,
};

WhoWeServes.defaultProps = {
  title: "",
  subTitle: "",
  partners: [],
};
